import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/**
 * Eligible destination classes for a one-off class change: the same subject as
 * the chosen origin class, taught in another shift of the student's opposition.
 * Disabled until an origin class is picked.
 */
export function useClassChangeDestinations(fromClassId) {
    return useQuery({
        queryKey: ['class-change-destinations', fromClassId],
        queryFn: () => apiClient(`/requests/me/class-change-destinations?from_class_id=${fromClassId}`),
        enabled: Boolean(fromClassId),
        staleTime: 1000 * 60,
    });
}
//# sourceMappingURL=useClassChangeDestinations.js.map